import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2 } from 'lucide-react';
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
const loadingSteps = (t) => [
    t('loading.processing_request'),
    t('loading.fetching_data'),
    t('loading.creating_answer'),
];
export const RichTypingIndicator = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [isVisible, setIsVisible] = useState(true);
    const { t } = useTranslation();
    const intervalRef = useRef(null);
    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setCurrentStep((prev) => {
                const nextStep = prev + 1;
                const lastStepIndex = loadingSteps(t).length - 1;
                if (nextStep > lastStepIndex) {
                    // We're already at the last step, clear interval and stop
                    if (intervalRef.current) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                    }
                    return prev;
                }
                // Start fade out animation
                setIsVisible(false);
                setTimeout(() => {
                    setCurrentStep(nextStep);
                    setIsVisible(true);
                    // If this was the last step, clear the interval
                    if (nextStep === lastStepIndex && intervalRef.current) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                    }
                }, 300); // Fade out duration
                return prev; // Return current step, will be updated in setTimeout
            });
        }, 2500); // Change step every 2.5 seconds
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [t]);
    return (_jsx("div", { className: "mt-8 flex flex-1 items-center", children: _jsxs("div", { className: `flex items-center gap-3 text-gray-600 transition-all duration-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`, children: [_jsx(Loader2, { className: "text-foreground-muted h-6 w-6 animate-spin" }), _jsx("span", { className: "text-foreground-muted text-xs leading-4", children: loadingSteps(t)[currentStep] })] }) }));
};
